
import { RangerSourceMapTypeInfoBase } from './ranger-source-map.typeinfo.base';


export class RangerSourceMapTypeInfo extends RangerSourceMapTypeInfoBase {
}

export const RANGER_SOURCE_MAP_TYPE: RangerSourceMapTypeInfo = new RangerSourceMapTypeInfo();



